export default "__VITE_ASSET__nxGO8_1E__"